var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-switch', _vm._b({
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.isActive,
      callback: function callback($$v) {
        _vm.isActive = $$v;
      },
      expression: "isActive"
    }
  }, 'v-switch', _vm.$attrs, false));
}
var staticRenderFns = []

export { render, staticRenderFns }